'use client'

import { ReactNode, useEffect, useRef } from "react"

type CarouselProps = {
    id: string,
    defaultInterval?: number
}

export function Carousel({
    id,
    defaultInterval = 5000
}: CarouselProps) {

    useEffect(() => {
        const load = async () => {

            console.log('init carousel')

            /*const slides = document.getElementById(id).querySelectorAll('.carousel-item')
            slides.forEach((el) => {
                if (el.querySelector('video') !== null) {
                    //el.setAttribute('data-bs-interval', String(el.querySelector('video').duration ? el.querySelector('video').duration * 1000 : defaultInterval))
                    el.setAttribute('data-bs-interval', String(8000))
                }
                else {
                    el.setAttribute('data-bs-interval', String(defaultInterval))
                }
            })*/

            const bootstrap = (await import('bootstrap/dist/js/bootstrap')).default;
            const carousel = new bootstrap.Carousel(document.getElementById(id), {
                ride: 'carousel'
            })

            document.getElementById(id).addEventListener('slide.bs.carousel', (e: any) => {
                // Pause la vidéo du slide qui part
                const leavingSlide = document.getElementById(id).querySelectorAll('.carousel-item')[e.from]
                leavingSlide?.querySelector('video')?.pause()

                // Joue la vidéo du slide qui arrive (pas de slide si le carousel est vide)
                const enteringSlide = document.getElementById(id).querySelectorAll('.carousel-item')[e.to]
                const enteringVideo = enteringSlide?.querySelector('video')
                if (enteringVideo) {
                    enteringVideo.currentTime = 0
                    enteringVideo.play()
                }
            })

            // Avance au slide suivant à la fin de chaque vidéo
            document.getElementById(id).querySelectorAll('.carousel-item video').forEach((video: HTMLVideoElement) => {
                video.addEventListener('ended', () => {
                    carousel.next()
                })
            })
            console.log('init carousel end')
        }

        load()

    }, [])

    return (
        <></>
    )
}